import styled, { css } from "styled-components";

// Medidas de docs/contexto-entrega/painel-entrega-documentacao_v2.md §3.
// Cores dos tokens do projeto e da identidade visual por empresa — os hexadecimais do
// documento de referência são do protótipo (DT 2.4).
//
// Largura mínima de 248px, crescendo com o conteúdo. Quem impede o crescimento de deslocar
// a mensagem central da barra é o CenterBlock de TopbarIdentidadeVisual, centrado em
// relação à barra inteira e não ao espaço restante.

export const Gatilho = styled.button`
  min-width: 248px;
  height: 44px;
  display: inline-flex;
  align-items: center;
  padding: 10px 16px;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  border-radius: 9999px;
  font-family: "DM Sans", system-ui, sans-serif;
  font-size: 1.3rem;
  font-weight: 600;
  text-align: left;
  white-space: nowrap;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    background-color: rgba(255, 255, 255, 0.12);
  }

  /* O protótipo não tem indicação de foco por teclado em lugar nenhum (divergência 8). */
  &:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }

  ${(props) =>
    props.variante === "atencao" &&
    css`
      color: ${({ theme }) => theme.colors.warning};
    `}

  /* Destaque temporario quando o CEP e alterado pelo card da pagina de produto, fora do
     campo de visao do cliente. */
  ${(props) =>
    props.destacado &&
    css`
      background-color: rgba(255, 255, 255, 0.25);
      transition: background-color 500ms cubic-bezier(0.4, 0, 0.2, 1);
    `}

  @media (max-width: 768px) {
    min-width: 0;
    padding: 10px 8px;
  }
`;

export const Conteudo = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

export const Texto = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${(props) =>
    props.variante === "vazio" &&
    css`
      text-decoration: underline dotted;
      text-underline-offset: 4px;
    `}

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Selo = styled.span`
  flex-shrink: 0;
  padding: 2px 8px;
  border-radius: 9999px;
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.warning};
  background-color: ${({ theme }) => theme.colors.info};

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Shimmer = styled.div`
  min-width: 248px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;

  @media (max-width: 768px) {
    min-width: 0;
  }
`;

const pulsar = css`
  background-color: rgba(255, 255, 255, 0.3);
  animation: pulseLocation 1.2s ease-in-out infinite;

  @keyframes pulseLocation {
    0%, 100% { opacity: 0.4; }
    50% { opacity: 1; }
  }
`;

export const ShimmerCirculo = styled.span`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  flex-shrink: 0;
  ${pulsar}
`;

export const ShimmerBarra = styled.span`
  width: 150px;
  height: 12px;
  border-radius: 9999px;
  ${pulsar}

  @media (max-width: 768px) {
    display: none;
  }
`;
